// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.column-header {
    font-weight: lighter;
    font-size: 14px;
    color: #9499a3;
}

.white-space-wrap {
    white-space: pre-wrap;
    margin-top: -16px;
    font-size: 18px;
}

.upsell-feedback-modal-table {
    overflow: auto;
    margin-top: 20px;
}

.data-column {
    width: calc(40vh - 100px);
}

.table {
    border-collapse: collapse !important;
}

.table-row {
    font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/upsell-feedback-modal/UpsellFeedbackModal.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".column-header {\n    font-weight: lighter;\n    font-size: 14px;\n    color: #9499a3;\n}\n\n.white-space-wrap {\n    white-space: pre-wrap;\n    margin-top: -16px;\n    font-size: 18px;\n}\n\n.upsell-feedback-modal-table {\n    overflow: auto;\n    margin-top: 20px;\n}\n\n.data-column {\n    width: calc(40vh - 100px);\n}\n\n.table {\n    border-collapse: collapse !important;\n}\n\n.table-row {\n    font-size: 16px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
